import { useQuery } from '@tanstack/react-query';
import { analyticsApi } from '../services/analytics-api.service';
import type { AnalyticsQueryParams } from '../types/analytics.types';

export const fpTopAdvisorsKeys = {
  all: ['analytics', 'fp-top-advisors'] as const,
  list: (params?: AnalyticsQueryParams) => [...fpTopAdvisorsKeys.all, 'list', params] as const,
};

export const useFPTopAdvisorsData = (params?: AnalyticsQueryParams, enabled = true) => {
  return useQuery({
    queryKey: fpTopAdvisorsKeys.list(params),
    queryFn: async () => {
      const response = await analyticsApi.getFPTopAdvisors(params);
      return response.data;
    },
    staleTime: 30 * 60 * 1000,
    enabled,
  });
};
